import { format } from "date-fns";
import styles from "../../styles/_containers/_coupons/table.module.scss";

const Table = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>היסטוריית מימושים לקופונים</h2>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>שם</th>
              <th>סוג הנחה</th>
              <th>מחיר</th>
              <th>תוקף</th>
              <th>משתמש</th>
              <th>שירות</th>
              <th>מחיר השירות</th>
              <th>מומש בתאריך</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>נראה שעדיין אין לך היסטוריית מימושים</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>{i.couponId.name}</td>
                <td>{i.couponId.priceType}</td>
                <td>₪{i.couponId.price}</td>
                <td>{format(new Date(i.couponId.expiryDate), "dd/MM/yyyy")}</td>
                <td>{i.userId.name}</td>
                <td>{i.serviceName}</td>
                <td>₪{i.serviceAmountOriginal}</td>
                <td>{format(new Date(i.createdAt), "dd/MM/yyyy")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
